// import Empresa from './Index.vue'
import Permissions from "../../models/Permissions";

const Empresa = () => import("./Index.vue");
// const EmpresaGeral = () => import('./EmpresaGeral.vue')
const EmpresaGeralNew = () => import("./EmpresaGeralNew.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const children = [
  // {
  //   path: '',
  //   name: 'empresa',
  //   meta: {
  //     requiresAuth: true,
  //     requiresCompany: false,
  //     showInMenu: true,
  //     label: 'Pesquisa',
  //     icon: 'fa fa-search',
  //     group: 'Cadastros',
  //     permissions
  //   }
  // },
  // {
  //   name: 'empresa.cadastro',
  //   path: 'cadastro',
  //   component: EmpresaGeral,
  //   props: true,
  //   params: { isNovo: true, value: {} },
  //   meta: {
  //     requiresAuth: true,
  //     requiresCompany: false,
  //     showInMenu: true,
  //     label: 'Cadastro',
  //     icon: 'fa fa-file',
  //     permissions
  //   }
  // },
  {
    path: "new/register",
    name: "new.register",
    component: EmpresaGeralNew,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Cadastro de Empresa",
      icon: "fa fa-pencil",
      group: "Cadastros",
      permissions,
    },
  },
];

export default [
  {
    path: "/empresa",
    component: Empresa,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Empresas",
      icon: "fa fa-building",
      group: "Cadastros",
      permissions,
    },
    children,
  },
];
